import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { trackCtaClick } from "../../constants/site";

export const StickyCta = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 560);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 90 }}
                    animate={{ y: 0 }}
                    exit={{ y: 90 }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    className="fixed inset-x-0 bottom-0 z-50 lg:hidden"
                    data-testid="sticky-mobile-cta"
                >
                    <div className="flex items-center justify-between gap-3 border-t border-gold/30 bg-plum/95 px-4 py-3 shadow-2xl shadow-plum/40 backdrop-blur">
                        <p className="font-sans text-[0.72rem] font-semibold leading-snug text-cream sm:text-sm">
                            Get the 5-Day Reset &mdash; <span className="text-gold">₹49</span>
                        </p>
                        <motion.a
                            data-testid="sticky-mobile-cta-button"
                            onClick={(e) => {
                                trackCtaClick("sticky-mobile-cta-button");
                                e.preventDefault();
                                window.dispatchEvent(new CustomEvent("open-checkout", { detail: { source: "sticky-mobile-cta" } }));
                            }}
                            whileTap={{ scale: 0.95 }}
                            className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-gradient-to-r from-goldlight to-gold px-4 py-2.5 font-sans text-[0.68rem] font-extrabold uppercase tracking-[0.12em] text-white"
                        >
                            Get Now
                            <ArrowRight className="h-3.5 w-3.5" />
                        </motion.a>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default StickyCta;
